import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CONTACT_INFO } from '@awo-care/shared-core';
import { BackToHomeComponent } from '../../../back-to-home/back-to-home.component';

// Variante MIT KI-Abschnitt liegt unter privacy.component.with-ai.html.bak
// (.bak, damit der i18n-Extractor sie nicht mit-scannt). Beim Reaktivieren der
// AI-Features (config/tickets.aiEnabled = true) den Inhalt der .bak-Datei in
// privacy.component.html übernehmen und die Section-Nummern entsprechend
// anpassen.

@Component({
  selector: 'awo-privacy',
  standalone: true,
  imports: [BackToHomeComponent],
  templateUrl: './privacy.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .privacy-container li > strong {
        display: contents;
      }

      .privacy-container li strong::after {
        content: ': ';
      }
    `,
  ],
})
export class PrivacyComponent {
  protected readonly contact = CONTACT_INFO;

  // Technical Provider properties
  company = this.contact.TECH_PROVIDER_COMPANY;
  name = this.contact.TECH_PROVIDER_NAME;
  address = this.contact.TECH_PROVIDER_ADDRESS_STREET;
  city = this.contact.TECH_PROVIDER_ADDRESS_CITY;
  email = this.contact.TECH_PROVIDER_EMAIL;

  // AWO Client properties
  clientAddress = this.contact.ADDRESS_FULL;
  clientCity =
    this.contact.ADDRESS_POSTAL_CODE + ' ' + this.contact.ADDRESS_CITY;
  clientName = this.contact.ORGANIZATION_NAME;
  clientEmail = this.contact.EMAIL_MAIN;
  clientDPOEmail = this.contact.DATA_PROTECTION_OFFICER_EMAIL;
}
